import { CustomValidatorArgs } from '../types/CSVTypes';
import isValidEmail from '../../../../helpers/isValidEmail';

const emailValidator = ({ value }: CustomValidatorArgs) => {
  if (!!value && !isValidEmail(value)) {
    return 'invalidEmail';
  }

  return null;
};

export default emailValidator;
